import React from "react";
import Section from "../../../components/section/section";
import { DashboardContext } from "./context/dashboardContext";
import IDashboardData, {
  IBooking,
  IRegistration,
} from "./interface/iDashboardData";
import Typography from "@mui/material/Typography";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Grid,
  Divider,
} from "@mui/material";

const DashboardContainer = (): React.JSX.Element => {
  const {
    dashboardData,
  }: {
    dashboardData: IDashboardData;
  } = React.useContext(DashboardContext);

  return (
    <React.Fragment>
      {dashboardData && (
        <React.Fragment>
          <Section>
            <Box
              sx={{
                p: 2,
                border: "1px solid",
                borderColor: (theme) => theme.palette.divider,
                borderRadius: 2,
                mb: 2,
              }}
            >
              <Typography variant="h6" color="initial">
                Heutige Daten
              </Typography>

              <Divider sx={{ mb: 1 }} />

              <Grid
                container
                spacing={0}
                sx={{
                  textAlign: "center",
                }}
              >
                <Grid item xs={12} sm={6} md={2}>
                  <Typography variant="caption" color="initial">
                    Anmeldungen
                  </Typography>
                  <Typography
                    variant="body1"
                    color="initial"
                    sx={{ fontWeight: "bold" }}
                  >
                    {dashboardData.sessionsToday}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={2}>
                  <Typography variant="caption" color="initial">
                    Buchungen
                  </Typography>
                  <Typography
                    variant="body1"
                    color="initial"
                    sx={{ fontWeight: "bold" }}
                  >
                    {dashboardData.bookings.length}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={2}>
                  <Typography variant="caption" color="initial">
                    Registrierungen
                  </Typography>
                  <Typography
                    variant="body1"
                    color="initial"
                    sx={{ fontWeight: "bold" }}
                  >
                    {dashboardData.registraions.length}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    p: 2,
                    border: "1px solid",
                    borderColor: (theme) => theme.palette.divider,
                    borderRadius: 2,
                    mb: 2,
                  }}
                >
                  <Typography variant="h6" color="initial">
                    Buchungen
                  </Typography>

                  <Divider sx={{ mb: 1 }} />

                  <List>
                    {dashboardData.bookings.map(
                      (booking: IBooking, index: number) => (
                        <ListItem
                          key={index}
                          sx={{
                            p: 0,
                            mb: 1,
                            borderBottom: "1px solid",
                            borderColor: (theme) => theme.palette.divider,
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography variant="body1" color="initial">
                                {`${booking.appointmentDate} - ${booking.appointmentStart} 
                            Uhr bis ${booking.appointmentEnd} Uhr
                            bei ${booking.coach} 
                            durch ${booking.participant} 
                            `}
                              </Typography>
                            }
                          />
                        </ListItem>
                      )
                    )}
                  </List>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    p: 2,
                    border: "1px solid",
                    borderColor: (theme) => theme.palette.divider,
                    borderRadius: 2,
                    mb: 2,
                  }}
                >
                  <Typography variant="h6" color="initial">
                    Registrierungen
                  </Typography>

                  <Divider sx={{ mb: 1 }} />

                  <List>
                    {dashboardData.registraions.map(
                      (registraion: IRegistration, index: number) => (
                        <ListItem
                          key={index}
                          sx={{
                            p: 0,
                            mb: 1,
                            borderBottom: "1px solid",
                            borderColor: (theme) => theme.palette.divider,
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography variant="body1" color="initial">
                                {`${registraion.participant} / ${registraion.createdAt}`}
                              </Typography>
                            }
                          />
                        </ListItem>
                      )
                    )}
                  </List>
                </Box>
              </Grid>
            </Grid>

            <Box
              sx={{
                p: 2,
                border: "1px solid",
                borderColor: (theme) => theme.palette.divider,
                borderRadius: 2,
                mb: 2,
              }}
            >
              <Typography variant="h6" color="initial">
                Meistgenutzt
              </Typography>

              <Divider sx={{ mb: 1 }} />

              <Grid
                container
                spacing={2}
                sx={{
                  textAlign: "center",
                }}
              >
                <Grid item xs={12} sm={2}>
                  <Typography variant="caption" color="initial">
                    IP-Adresse
                  </Typography>
                  <Typography
                    variant="body1"
                    color="initial"
                    sx={{ fontWeight: "bold" }}
                  >
                    {dashboardData.traffic.mostCommonIpAddress}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="caption" color="initial">
                    Bildschirm Breite
                  </Typography>
                  <Typography variant="body1" color="initial">
                    {dashboardData.traffic.mostCommonScreenWidth}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="caption" color="initial">
                    Bildschirm Höhe
                  </Typography>
                  <Typography variant="body1" color="initial">
                    {dashboardData.traffic.mostCommonScreenHeight}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="caption" color="initial">
                    Bildschirm Breite (Viewport)
                  </Typography>
                  <Typography variant="body1" color="initial">
                    {dashboardData.traffic.mostCommonViewportWidth}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="caption" color="initial">
                    Bildschirm Höhe (Viewport)
                  </Typography>
                  <Typography variant="body1" color="initial">
                    {dashboardData.traffic.mostCommonViewportHeight}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="caption" color="initial">
                    Sprache
                  </Typography>
                  <Typography variant="body1" color="initial">
                    {dashboardData.traffic.mostCommonUserLanguage}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="caption" color="initial">
                    Browser
                  </Typography>
                  <Typography variant="body1" color="initial">
                    {dashboardData.traffic.mostCommonUserAgent}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                p: 2,
                border: "1px solid",
                borderColor: (theme) => theme.palette.divider,
                borderRadius: 2,
              }}
            >
              <Typography variant="body1" color="initial">
                Top Ten
              </Typography>

              <Divider sx={{ mb: 1 }} />

              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <Typography variant="caption" color="initial">
                    Häufigste IP-Adressen
                  </Typography>

                  <List>
                    {Object.keys(dashboardData.traffic.ipAddressCount)
                      .sort(
                        (a: string, b: string) =>
                          dashboardData.traffic.ipAddressCount[b] -
                          dashboardData.traffic.ipAddressCount[a]
                      )
                      .map((ipAddress: string, index: number) => (
                        <ListItem
                          key={index}
                          sx={{
                            p: 0,

                            borderBottom: "1px solid",
                            borderColor: (theme) => theme.palette.divider,
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography variant="body1" color="initial">
                                {ipAddress}
                              </Typography>
                            }
                            secondary={`Anzahl: ${dashboardData.traffic.ipAddressCount[ipAddress]}`}
                          />
                        </ListItem>
                      ))}
                  </List>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <Typography variant="caption" color="initial">
                    Häufigste Bildschirm Breiten
                  </Typography>

                  <List>
                    {Object.keys(dashboardData.traffic.screenHeightCount)
                      .sort(
                        (a: string, b: string) =>
                          dashboardData.traffic.screenHeightCount[b] -
                          dashboardData.traffic.screenHeightCount[a]
                      )
                      .map((ipAddress: string, index: number) => (
                        <ListItem
                          key={index}
                          sx={{
                            p: 0,

                            borderBottom: "1px solid",
                            borderColor: (theme) => theme.palette.divider,
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography variant="body1" color="initial">
                                {ipAddress}
                              </Typography>
                            }
                            secondary={`Anzahl: ${dashboardData.traffic.screenHeightCount[ipAddress]}`}
                          />
                        </ListItem>
                      ))}
                  </List>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <Typography variant="caption" color="initial">
                    Häufigste Bildschirm Höhen
                  </Typography>

                  <List>
                    {Object.keys(dashboardData.traffic.screenWidthCount)
                      .sort(
                        (a: string, b: string) =>
                          dashboardData.traffic.screenWidthCount[b] -
                          dashboardData.traffic.screenWidthCount[a]
                      )
                      .map((ipAddress: string, index: number) => (
                        <ListItem
                          key={index}
                          sx={{
                            p: 0,

                            borderBottom: "1px solid",
                            borderColor: (theme) => theme.palette.divider,
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography variant="body1" color="initial">
                                {ipAddress}
                              </Typography>
                            }
                            secondary={`Anzahl: ${dashboardData.traffic.screenWidthCount[ipAddress]}`}
                          />
                        </ListItem>
                      ))}
                  </List>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <Typography variant="caption" color="initial">
                    Häufigste Sprache
                  </Typography>

                  <List>
                    {Object.keys(dashboardData.traffic.userLanguageCount)
                      .sort(
                        (a: string, b: string) =>
                          dashboardData.traffic.userLanguageCount[b] -
                          dashboardData.traffic.userLanguageCount[a]
                      )
                      .map((ipAddress: string, index: number) => (
                        <ListItem
                          key={index}
                          sx={{
                            p: 0,

                            borderBottom: "1px solid",
                            borderColor: (theme) => theme.palette.divider,
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography variant="body1" color="initial">
                                {ipAddress}
                              </Typography>
                            }
                            secondary={`Anzahl: ${dashboardData.traffic.userLanguageCount[ipAddress]}`}
                          />
                        </ListItem>
                      ))}
                  </List>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <Typography variant="caption" color="initial">
                    Häufigste Browser
                  </Typography>

                  <List>
                    {Object.keys(dashboardData.traffic.userAgentCount)
                      .sort(
                        (a: string, b: string) =>
                          dashboardData.traffic.ipAddressCount[b] -
                          dashboardData.traffic.ipAddressCount[a]
                      )
                      .map((ipAddress: string, index: number) => (
                        <ListItem
                          key={index}
                          sx={{
                            p: 0,

                            borderBottom: "1px solid",
                            borderColor: (theme) => theme.palette.divider,
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography variant="body1" color="initial">
                                {ipAddress}
                              </Typography>
                            }
                            secondary={`Anzahl: ${dashboardData.traffic.userAgentCount[ipAddress]}`}
                          />
                        </ListItem>
                      ))}
                  </List>
                </Grid>
              </Grid>
            </Box>
          </Section>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default DashboardContainer;
